(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cero-language-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('CeroLanguageForm');
    const select = document.getElementById('CeroLanguageSelect');
    const context = document.getElementById('CeroLocaleContext');
    if (!form || !select || !context) return;

    select.addEventListener('change', () => {
      sessionStorage.setItem('cero-language-chosen', 'true');
      form.submit();
    });

    if (sessionStorage.getItem('cero-language-chosen')) return;
    const spanishCountries = ['AR','BO','CL','CO','CR','DO','EC','SV','GT','HN','MX','NI','PA','PY','PE','PR','ES','UY','VE'];
    const desired = context.dataset.country === 'BR' ? 'pt-BR' : (spanishCountries.includes(context.dataset.country) ? 'es' : 'en');
    const hasDesired = Array.from(select.options).some((option) => option.value === desired);
    if (hasDesired && context.dataset.language !== desired) {
      sessionStorage.setItem('cero-language-chosen', 'true');
      select.value = desired;
      form.submit();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cero-measurement-instructions"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){const link=event.target.closest('[data-measurements-link]');if(!link)return;const href=link.getAttribute('href');if(!href||href.charAt(0)!=='#')return;const target=document.getElementById(href.slice(1));if(!target)return;event.preventDefault();let node=target;while(node){if(node.tagName==='DETAILS')node.open=true;node=node.parentElement;}requestAnimationFrame(function(){target.scrollIntoView({behavior:'smooth',block:'start'});const summary=target.querySelector('summary');if(summary)summary.focus({preventScroll:true});});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cero-search"] && !Shopify.designMode) return;
  try {
    const sizeAliases = {
    s: 'talle-s', small: 'talle-s',
    m: 'talle-m', medium: 'talle-m',
    l: 'talle-l', large: 'talle-l',
    xl: 'talle-xl', 'extra large': 'talle-xl',
    xxl: 'talle-xxl', '2xl': 'talle-xxl', '2 extra large': 'talle-xxl',
    '3xl': 'talle-3xl', '3 extra large': 'talle-3xl',
    '4xl': 'talle-4xl', '4 extra large': 'talle-4xl',
    '28': 'talle-28', '30': 'talle-30', '32': 'talle-32', '34': 'talle-34',
    '36': 'talle-36', '38': 'talle-38', '40': 'talle-40', '42': 'talle-42'
  };

  document.querySelectorAll('[data-cero-search-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      const input = form.querySelector('input[name="q"]');
      const normalized = input.value.trim().toLowerCase().replace(/^(?:talle|talla|size|tamanho)\s+/i, '');
      const sizeTag = sizeAliases[normalized];

      if (sizeTag) {
        event.preventDefault();
        window.location.assign(`${form.dataset.collectionsUrl}/shop-all/${sizeTag}`);
        return;
      }

      const match = input.value.trim().match(/^(?:oft(?:fit)?\s*)?(\d+)$/i);
      if (!match) return;

      event.preventDefault();
      const outfitNumber = match[1];
      const searchUrl = new URL('/search/suggest.json', window.location.origin);
      searchUrl.searchParams.set('q', outfitNumber);
      searchUrl.searchParams.set('resources[type]', 'product');
      searchUrl.searchParams.set('resources[options][unavailable_products]', 'hide');
      searchUrl.searchParams.set('resources[limit]', '10');
      searchUrl.searchParams.set('resources[options][fields]', 'title');

      try {
        const response = await fetch(searchUrl);
        const data = await response.json();
        const products = data.resources.results.products || [];
        const expectedTitle = `outfit cero ${outfitNumber}`;
        const outfit = products.find((product) => product.title.trim().toLowerCase() === expectedTitle);
        if (outfit) {
          window.location.assign(outfit.url);
          return;
        }
      } catch {
      }

      input.value = outfitNumber;
      form.submit();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
